import { useEffect } from "react";

/**
 * /game-arttoy/serialcode
 * หน้า placeholder ระหว่างรอเปิดเกม — แสดงข้อความ "Game coming soon" กลางหน้า
 * ใช้โทนสีเดียวกับระบบ (primary #93c93d, text #111111, bg #f6f6f6)
 */
const GameArtToy = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Art Toy | Big C";
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-secondary-background px-6">
      <div className="flex w-full max-w-md flex-col items-center text-center">
        <div
          className="mb-6 flex h-20 w-20 items-center justify-center rounded-full"
          style={{ backgroundColor: "rgba(147, 201, 61, 0.15)" }}
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#93c93d"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
          </svg>
        </div>

        <h1
          className="text-2xl font-semibold"
          style={{ color: "#111111" }}
        >
          Game coming soon
        </h1>

        <p className="mt-3 text-sm" style={{ color: "#6b6b6b" }}>
          เตรียมพบกับกิจกรรมสุดพิเศษเร็ว ๆ นี้
        </p>

        <div
          className="mt-6 h-1 w-16 rounded-full"
          style={{ backgroundColor: "#93c93d" }}
        />
      </div>
    </div>
  );
};

export default GameArtToy;
